module.exports = __webpack_public_path__ + "static/media/Altramuces.29d5bb3f.png";